export enum Metrics {
  ATTRIBUTED_SALES = 'SUM_ATTRIBUTED_SALES',
  ATTRIBUTED_ERV = 'SUM_ATTRIBUTED_ERV',
  ATTRIBUTED_UNITS_SOLD = 'SUM_ATTRIBUTED_UNITS_SOLD',
  ORDER_COUNT = 'COUNT_ORDER',
  AVG_GMV = 'AVG_GMV',
  AVG_ORDERED_ITEM = 'AVG_ORDERED_ITEM',
  NUM_DISTINCT_FLYERS = 'NUM_DISTINCT_FLYERS',
  GROSS_IMPRESSIONS = 'SUM_GROSS_IMPRESSIONS',
  VISIT_IMPRESSIONS = 'SUM_VISIT_IMPRESSIONS',
  USER_IMPRESSIONS = 'SUM_USER_IMPRESSIONS',
  GROSS_ADD_TO_CARTS = 'SUM_GROSS_ADD_TO_CARTS',
  VISIT_ADD_TO_CARTS = 'SUM_VISIT_ADD_TO_CARTS',
  USER_ADD_TO_CARTS = 'SUM_USER_ADD_TO_CARTS',
  GROSS_CLICK_THROUGH_RATE = 'GROSS_CLICK_THROUGH_RATE',
  VISIT_CLICK_THROUGH_RATE = 'VISIT_CLICK_THROUGH_RATE',
  USER_CLICK_THROUGH_RATE = 'USER_CLICK_THROUGH_RATE',
  LAST_ETL_UPDATE = 'MAX_UPDATED_AT_DATE_TIME_UTC',
}

export enum Dimensions {
  DATE_PT = 'DATE_PT',
  WEEK_SAT_PT = 'WEEK_SAT_PT',
  WEEK_SUN_PT = 'WEEK_SUN_PT',
  WEEK_MON_PT = 'WEEK_MON_PT',
  WEEK_TUE_PT = 'WEEK_TUE_PT',
  WEEK_WED_PT = 'WEEK_WED_PT',
  WEEK_THU_PT = 'WEEK_THU_PT',
  WEEK_FRI_PT = 'WEEK_FRI_PT',
  MONTH_PT = 'MONTH_PT',
  PARTNER = 'PARTNER',
  WAREHOUSE = 'WAREHOUSE',
  WAREHOUSE_LOCATION = 'WAREHOUSE_LOCATION',
  WAREHOUSE_LOCATION_CODE = 'WAREHOUSE_LOCATION_CODE',
  WAREHOUSE_LOCATION_GROUP = 'WAREHOUSE_LOCATION_GROUP',
  WAREHOUSE_LOCATION_STATE = 'WAREHOUSE_LOCATION_STATE',
  PLATFORM = 'PLATFORM',
  STORE_REGION = 'STORE_REGION',
  FLYER_ID = 'FLYER_ID',
  FLYER_NAME = 'FLYER_NAME',
  FLYER_TAG = 'FLYER_TAG',
}
